import { fetcher } from 'features/shared/utils/fetcher'

export type createTenantProps = {
  owner_name: string
  owner_email: string
  owner_password: string
  owner_phone: string
  plan_code: string
  subdomain: string
  country_code: string
  timezone?: string
  metadata?: object
  hubspot_utk?: string
  currency_code?: string
  locale: string
  recaptcha: string
}

async function createTenant(props: createTenantProps) {
  const lead = await fetcher.post<{ id: string }>('/v1/leads', props)

  let meta: { url?: string; access_token?: string } = {}

  await new Promise<void>((resolve, reject) => {
    ;(async function waitForCompleted() {
      try {
        const retryTimeInMS = 2000
        const response = await fetcher.get<{
          status: 'complete'
          meta?: {
            url: string
            access_token: string
          }
        }>(`/v1/leads/${lead.id}/status`)

        if (response.status === 'complete') {
          if (response.meta) {
            meta = response.meta
          }
          return resolve()
        }

        setTimeout(waitForCompleted, retryTimeInMS)
      } catch (error) {
        reject(error)
      }
    })()
  })

  if (!meta.url || !meta.access_token) {
    throw new Error('Missing required meta data (url or access_token)')
  }

  return `${meta.url}?access_token=${meta.access_token}`
}

export default createTenant
